import React, { useRef, useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { ThemeContext } from '../ThemeProvider';

import { isMobile, isBrowser } from 'react-device-detect';

import { getProfileInfo } from "../api/ApiCall";


import '../index.css';
import Header from "../element/Header";
import AppDetails from "../page_h/AppDetails";
import SplashPage from "./SplashPage";


import Design2 from '../images/test_img_2.png';

//icon
import { FaCode, FaPhone } from "react-icons/fa6";
import { FaArrowRight } from "react-icons/fa";
import { IoPerson } from "react-icons/io5";
import { MdEmail } from "react-icons/md";
import { FiGlobe } from "react-icons/fi";
import Hero from "../element/Hero";
import Skills from "../element/Skills";
import About from "../element/About";
import { CgPhone } from "react-icons/cg";






function HomePage() {

  //theme
  const { isDarkMode, toggleTheme } = useContext(ThemeContext);


  //data
  const [loading, setLoading] = useState(true);
  const [loadingTime, setLoadtingTime] = useState(true);
  const [profileData, setProfileData] = useState(null);

  //filter
  const [activeFilter, setActiveFilter] = useState("all");

  const filteredProjects = profileData?.project_list?.filter((item) => {
    if (activeFilter === "all") return true;
    if (activeFilter === "client") return item.own === "client";
    return item.project_type === activeFilter;
  });









  //
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);

      //data get
      getProfileInfo()
        .then((response) => {
          const jsonObject = response.data;

          if (jsonObject.result_code === 1) {
            setProfileData(jsonObject.data);
          } else {
            setProfileData(null);
          }
        })
        .catch(() => {
          setProfileData(null);
        })
        .finally(() => {
          setLoading(false);
        });

      const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));
      await delay(1000);
      setLoadtingTime(false);
    };

    fetchData();
  }, []);



  //header info
  const headerInfo = [
    { "title": "Home", "id": "home" },
    { "title": "About", "id": "about" },
    { "title": "Project", "id": "project" },
  ]


  const headerCallBack = (id) => {
    if (id === "reload") {  window.location.reload(); } 
    else if (id === "home_page") { window.location.href = "/profile"; } 
    else if (id === "home") { scrollToElement(home_ref); } 
    else if (id === "about") { scrollToElement(about_ref); } 
    else if (id === "project") { scrollToElement(project_ref); }
  };


  const scrollToElement = (ref) => {
    ref.current.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest', easing: 'ease-in-out' });
  };
 





  //mouse
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const handleMouseMove = (e) => {
      setMousePosition({
        x: e.clientX,
        y: e.clientY,
      });
    };

    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, []);






  //all refs
  const home_ref = useRef(null);
  const about_ref = useRef(null);
  const project_ref = useRef(null);
  const scrollToTargetDiv = (ref) => {
    if (ref.current) { ref.current.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest', easing: 'ease-in-out' }); }
  };









  return (
    <div className="flex flex-col h-screen">
      {(loading || loadingTime || profileData === null) ? (<SplashPage />)
        : (
          <div className="custom-scrollbar-p  flex justify-between bg-fj" >

            {/* //cursor */}
            {isBrowser && (
              <div
                className={`xpro-mouse-cursor ${
                  isDarkMode ? "xpro-mouse-cursor-dark" : ""
                }`}
                data-delay="0.5"
                style={{
                  transform: `translate(${mousePosition.x}px, ${mousePosition.y}px)`,
                }}
              />
            )}

            



            {/* //header */}
            <Header logoInfo={"code"} info={headerInfo} callBack={(id) => headerCallBack(id)} />


            <div ref={home_ref} className="w-full flex flex-col rounded-md mx-auto"  >


              <Hero profileData={profileData} nextRef={about_ref} />

              <About currRef={about_ref} profileData={profileData}  />

              <Skills profileData={profileData} />



              {/* //project list */}
              <div className="" ref={project_ref}>
                {/* //project title */}
                <div className="flex items-center justify-center">
                  <span className="text-6xl font-bold pt-30 font-fantasy">Projects</span>
                </div>

                <div className="h-8"></div>
                <div className="h-8"></div>

                {/* //filter */}
                <div className="flex items-center justify-center gap-4 flex-wrap mb-4">
                  {["all", "web", "android", "kmp", "client"].map((item) => (
                    <div
                      onClick={() => setActiveFilter(item)}
                      className={`layout_2_ flex justify-center py-2 px-7 rounded-lg font-bold capitalize
                      ${activeFilter === item ? "is-selected" : ""}
                    `}
                    >
                      {item}
                    </div>

                  ))}
                </div>


                <div className="h-8"></div>



                {/* //project list */}
                {filteredProjects?.length > 0 ? (
                  filteredProjects.map((item, index) => (
                    <AppDetails index={index} projectData={item} />
                  ))
                ) : (
                  <div>
                    <div className="h-48"></div>
                    <p className="text-center text-white mt-4 text-xl">
                      No projects found 🚫
                    </p>
                    <div className="h-48"></div>
                  </div>
                )}

              </div>







              {/* //div contect with us */}
              <div className="w-full h-10" >
                <img src={Design2} alt="" className="w-full h-full"></img>
              </div>


              <div className="w-full min-h-96 bg-white flex flex-col items-center justify-center">
                <FaCode className="w-14 h-14 cursor-pointer" style={{ color: 'black' }} />
                <span className="text-5xl font-bold p-6" style={{ fontFamily: "cursive", color: 'black' }}>Work With US</span>
                <button className="button_2 flex flex-row items-center justify-center m-2 px-4 py-2" onClick={() => scrollToTargetDiv(about_ref)}>
                  <IoPerson className="w-6 h-6" style={{ color: 'white' }} />
                  <span className=" font-bold px-2">Connect</span>
                  <FaArrowRight className="w-5 h-5" style={{ color: 'white' }} />
                </button>
              </div>

              <div className="w-full h-10 rotate-180" >
                <img src={Design2} alt="" className="w-full h-full"></img>
              </div>






              {/* //footer */}
              <div className="screen_container h-70 m b-4 flex flex-col flex-start p-5 w-full" >
                <div className="flex flex-row items-center py-2">
                  <IoPerson className="w-7 h-7" style={{ color: 'white' }} />
                  <span className=" font-bold text-2xl p-2">Contact</span>
                </div>

                <div className="flex flex-row items-center">
                  <MdEmail className="w-5 h-5" style={{ color: 'white' }} />
                  <span className=" font-bold p-1">Email: </span>
                  <a className="p-1" href={`mailto:${encodeURIComponent(profileData.emailId)}`}>
                    {profileData.emailId}
                  </a>
                </div>

                <div className="flex flex-row items-center">
                  <FiGlobe className="w-5 h-5" style={{ color: 'white' }} />
                  <span className=" font-bold p-1">Site: </span>
                  <span className=" p-1">{profileData.site}</span>
                </div>

                <div className="flex flex-row items-center">
                  <FaPhone className="w-5 h-5" style={{ color: 'white' }} />
                  <span className=" font-bold p-1">Phone No: </span>
                  <span className=" p-1">{profileData.phone}</span>
                </div>
              </div>



            </div>

          </div>
        )}
    </div>
  )
}


export default HomePage;